var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: { animation: "slide", open: _vm.isOpen, "data-cy": "gops-data" },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "header",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Oferta de crédito "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "section",
        { staticClass: "card-block p-0 pb-1" },
        [
          _c(
            "div",
            { staticClass: "subcard" },
            [
              _c(
                "b-field",
                {
                  staticClass: "has-addons",
                  attrs: { label: "Monto total crédito", horizontal: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "number",
                          placeholder: "Ingresa valor en UF",
                          expanded: "",
                        },
                        model: {
                          value: _vm.simulation.offerResponse.creditAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.simulation.offerResponse,
                              "creditAmount",
                              $$v
                            )
                          },
                          expression: "simulation.offerResponse.creditAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-field",
                {
                  staticClass: "has-addons",
                  attrs: { label: "Monto financiamiento", horizontal: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "number",
                          placeholder: "Ingresa valor en UF",
                          expanded: "",
                        },
                        model: {
                          value: _vm.simulation.offerResponse.financingAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.simulation.offerResponse,
                              "financingAmount",
                              $$v
                            )
                          },
                          expression:
                            "simulation.offerResponse.financingAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-field",
                {
                  staticClass: "has-addons",
                  attrs: { label: "Monto líquido requerido", horizontal: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "number",
                          placeholder: "Ingresa valor en UF",
                          expanded: "",
                        },
                        model: {
                          value:
                            _vm.simulation.offerResponse
                              .amountRequestedByClient,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.simulation.offerResponse,
                              "amountRequestedByClient",
                              $$v
                            )
                          },
                          expression:
                            "simulation.offerResponse.amountRequestedByClient",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-field",
                {
                  staticClass: "has-addons",
                  attrs: { label: "Monto bruto requerido", horizontal: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "number",
                          placeholder: "Ingresa valor en UF",
                          expanded: "",
                        },
                        model: {
                          value: _vm.simulation.offerResponse.credituAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.simulation.offerResponse,
                              "credituAmount",
                              $$v
                            )
                          },
                          expression: "simulation.offerResponse.credituAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "subcard is-gray" },
            [
              _c(
                "b-field",
                {
                  staticClass: "has-addons",
                  attrs: { label: "¿Monto máx. a prestar?", horizontal: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        staticClass: "pr-2",
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "number",
                          placeholder: "Ingresa valor de la propiedad",
                          expanded: "",
                        },
                        model: {
                          value: _vm.simulation.offerResponse.approvedAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.simulation.offerResponse,
                              "approvedAmount",
                              $$v
                            )
                          },
                          expression: "simulation.offerResponse.approvedAmount",
                        },
                      }),
                      _c("b-button", {
                        staticClass: "header-icon",
                        attrs: {
                          size: "is-small",
                          "data-cy": "propertiesMaximumAmount",
                          "icon-left": _vm.propertiesMaximumAmount
                            ? "angle-down"
                            : "angle-right",
                        },
                        on: { click: _vm.togglePropertiesMaximumAmount },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm.propertiesMaximumAmount
                ? _c(
                    "div",
                    { staticClass: "fields-has-text-right" },
                    [
                      _c(
                        "b-field",
                        {
                          staticClass: "has-addons",
                          attrs: {
                            label: "Máx. por carga financiera",
                            horizontal: "",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field has-addons" },
                            [
                              _c("p", { staticClass: "control" }, [
                                _c("a", { staticClass: "button is-static" }, [
                                  _vm._v("UF"),
                                ]),
                              ]),
                              _c("b-input", {
                                attrs: {
                                  disabled: _vm.readOnly,
                                  size: "is-small",
                                  type: "number",
                                  placeholder: "Ingresa el valor",
                                  expanded: "",
                                },
                                model: {
                                  value:
                                    _vm.simulation.offerResponse
                                      .approvedAmountFinanceCharge,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.simulation.offerResponse,
                                      "approvedAmountFinanceCharge",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "simulation.offerResponse.approvedAmountFinanceCharge",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "has-addons",
                          attrs: {
                            label: "Máx. por dividiendo-renta",
                            horizontal: "",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field has-addons" },
                            [
                              _c("p", { staticClass: "control" }, [
                                _c("a", { staticClass: "button is-static" }, [
                                  _vm._v("UF"),
                                ]),
                              ]),
                              _c("b-input", {
                                attrs: {
                                  disabled: _vm.readOnly,
                                  size: "is-small",
                                  type: "number",
                                  placeholder: "Ingresa el valor",
                                  expanded: "",
                                },
                                model: {
                                  value:
                                    _vm.simulation.offerResponse
                                      .approvedAmountIncomeDividend,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.simulation.offerResponse,
                                      "approvedAmountIncomeDividend",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "simulation.offerResponse.approvedAmountIncomeDividend",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "has-addons",
                          attrs: {
                            label: "Máx. por deuda garantía",
                            horizontal: "",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field has-addons" },
                            [
                              _c("p", { staticClass: "control" }, [
                                _c("a", { staticClass: "button is-static" }, [
                                  _vm._v("UF"),
                                ]),
                              ]),
                              _c("b-input", {
                                attrs: {
                                  disabled: _vm.readOnly,
                                  size: "is-small",
                                  type: "number",
                                  placeholder: "Ingresa el valor",
                                  expanded: "",
                                },
                                model: {
                                  value:
                                    _vm.simulation.offerResponse
                                      .approvedAmountLoanToValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.simulation.offerResponse,
                                      "approvedAmountLoanToValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "simulation.offerResponse.approvedAmountLoanToValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("dividend-sub-card", {
            attrs: {
              simulation: _vm.simulation,
              "show-content": _vm.showDividend,
              "read-only": _vm.readOnly,
            },
          }),
          _c("maximum-quota-sub-card", {
            attrs: {
              simulation: _vm.simulation,
              "show-content": _vm.showMaximumQuota,
              "read-only": _vm.readOnly,
            },
          }),
          _c("div", { staticClass: "subcard is-gray" }, [
            _c(
              "div",
              { staticClass: "subcard-header" },
              [
                _c("p", { staticClass: "header-title" }, [
                  _vm._v("Ratios financieros"),
                ]),
                _c("b-button", {
                  staticClass: "header-icon",
                  attrs: {
                    size: "is-small",
                    "icon-left": _vm.propertiesFinancialRatios
                      ? "angle-up"
                      : "angle-down",
                  },
                  on: { click: _vm.togglePropertiesFinancialRatios },
                }),
              ],
              1
            ),
            _vm.propertiesFinancialRatios
              ? _c(
                  "div",
                  { staticClass: "subcard-content fields-has-text-right" },
                  [
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Carga financiera", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("%"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Ingresa valor",
                                value: _vm.formatPercentage(
                                  _vm.simulation.offerResponse.backEndRatio
                                ),
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Dividendo-renta", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("%"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Ingresa valor",
                                value: _vm.formatPercentage(
                                  _vm.simulation.offerResponse.frontEndRatio
                                ),
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Deuda-garantía", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("%"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Ingresa valor",
                                value: _vm.formatPercentage(
                                  _vm.simulation.offerParams.maximumCreditLTV
                                ),
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Pie", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("%"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Ingresa valor",
                                value: _vm.formatPercentage(
                                  _vm.simulation.offerResponse.loanToValueHome
                                ),
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Cobertura", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("%"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Ingresa valor",
                                value: _vm.formatPercentage(
                                  _vm.simulation.offerResponse.financingRatio
                                ),
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }